import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

import SearchParamsGuard from './SearchParamsGuard';

const routes: RouteObject[] = [
  {
    path: 'member',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: () => {
          return (
            <SearchParamsGuard
              configs={[
                {
                  prefix: 'user',
                  limit: 50,
                  offset: 0,
                },
              ]}
            />
          );
        },
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/user/MemberListPage')),
          },
        ],
      },
    ],
  },
];

export default routes;
